export default __webpack_public_path__ + "static/media/category-banner-SellerWins.20c5a34e.jpg";